import { render, staticRenderFns } from "./userFormExternal.vue?vue&type=template&id=27d02836&"
import script from "./userFormExternal.vue?vue&type=script&lang=js&"
export * from "./userFormExternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports